import { useParams } from "react-router-dom";
import { useIdea } from "../../../w2d2d-api-client";
import { useSession } from "@toolpad/core";
import Session from "../../../../appfw/authentication/Session";
import { useEffect, useState } from "react";
import EventIdeaView from "../../components/events/event-idea-view.tsx";
import { useW2d2dPod } from "../../hooks/useW2d2dPod.ts";
import { useIdeasControl } from "../../hooks/useIdeasControl.tsx";
import { ResourceWrapper } from "../../../../eventer-pod/client/ResourceWrapper.ts";
import { ideaToEvent } from "../../../ideas/idea-to-event.ts";
import LoadingScreen from "../../../../appfw/ui/loading/loading-screen.tsx";

export default function IdeaPage() {

    const { id } = useParams()

    const session = useSession<Session>()
    const pod = useW2d2dPod()

    const { ideas } = useIdeasControl()
    const ideaControl = ideas?.find(i => i.id === id)

    const ideaHook = useIdea(id!!)
    const idea = ideaControl || ideaHook.data

    const [event, setEvent] = useState<ResourceWrapper | undefined>(undefined)

    useEffect(() => {
        if (!pod || !session?.id || !idea) {
            return
        }

        const sessionId = session.id

        if (idea.eventUri) {
            let active = true
            pod.getResource({ uri: idea.eventUri, sessionId, importOptions: { ifMissing: true } })
                .then((resource) => {
                    if (active) {
                        if (resource) {
                            setEvent(resource)
                        } else {
                            // fallback if resource not found?
                            setEvent(ideaToEvent(idea))
                        }
                    }
                })
                .catch((err) => {
                    console.error("Failed to load event:", err)
                    if (active) {
                        setEvent(ideaToEvent(idea))
                    }
                })
            return () => {
                active = false
            }
        } else {
            setEvent(ideaToEvent(idea))
        }
    }, [pod, idea, session])

    if (!idea || !session) {
        // Loading or invalid state
        // original code had `if (!idea) return` (rendering nothing).
        return <LoadingScreen message="Lade Idee" />
    }

    if (!event) {
        return <LoadingScreen message="Lade Details" />
    }

    return (
        <EventIdeaView event={event} idea={idea} />
    )
}
